/**
 * 貼文可見性設定 Modal — 薄殼，內容由 PostVisibilityForm 提供。
 * MyPost / WorldCreate 等獨立場景使用；
 * PostEditModal 不走 modal，直接 inline render PostVisibilityForm。
 *
 * 確認/取消按鈕統一放 Modal.Footer（全站 modal 慣例），
 * 透過 formRef 呼叫 PostVisibilityForm 暴露的 confirm()。
 */
import { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PostVisibilityForm from './PostVisibilityForm';

const PostVisibilityModal = forwardRef(({ onConfirm }, ref) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [canConfirm, setCanConfirm] = useState(true);
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    show: (data = {}) => {
      setInitialValues({
        visibilityType: data.visibilityType,
        unlockPrice: data.unlockPrice,
      });
      setShow(true);
    },
    hide: () => setShow(false),
  }));

  const handleClose = () => setShow(false);

  const handleConfirm = (values) => {
    onConfirm?.(values);
    setShow(false);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="border-bottom pb-3" closeButton>
        <Modal.Title className="fw-bold">{t('post_visibility_settings')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PostVisibilityForm
          ref={formRef}
          initialValues={initialValues}
          onConfirm={handleConfirm}
          onValidityChange={setCanConfirm}
        />
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex justify-content-end gap-2">
        <button className="btn btn-neutral rounded-pill" onClick={handleClose}>
          {t('cancel')}
        </button>
        <button
          className="btn btn-primary rounded-pill"
          onClick={() => formRef.current?.confirm()}
          disabled={!canConfirm}
        >
          {t('confirm')}
        </button>
      </Modal.Footer>
    </Modal>
  );
});

PostVisibilityModal.displayName = 'PostVisibilityModal';

export default PostVisibilityModal;
